import { ScrollView } from 'react-native';

import {
  PartnerLineItemAllergen,
  PartnerLineItemAllergens,
  PartnerLineItemBody,
  PartnerLineItemContainer,
  PartnerLineItemDetails,
  PartnerLineItemFloatingActions,
  PartnerLineItemFloatingButton,
  PartnerLineItemHero,
  PartnerLineItemIngredient,
  PartnerLineItemIngredients,
  PartnerLineItemNavigationHeader,
  PartnerLineItemNutrition,
  PartnerLineItemNutritionItem,
  PartnerLineItemNutritionNotice,
} from './components';

export const PartnerLineItem = {
  Container: PartnerLineItemContainer,
  NavigationHeader: PartnerLineItemNavigationHeader,
  ScrollView,
  Body: PartnerLineItemBody,
  Hero: PartnerLineItemHero,
  Ingredients: PartnerLineItemIngredients,
  Ingredient: PartnerLineItemIngredient,
  Details: PartnerLineItemDetails,
  Allergens: PartnerLineItemAllergens,
  Allergen: PartnerLineItemAllergen,
  Nutrition: PartnerLineItemNutrition,
  NutritionItem: PartnerLineItemNutritionItem,
  NutritionNotice: PartnerLineItemNutritionNotice,
  FloatingActions: PartnerLineItemFloatingActions,
  FloatingButton: PartnerLineItemFloatingButton,
};
